import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TrinityService } from '../services/trinity.service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSelect } from '@angular/material/select';
import { get } from 'http';

@Component({
  selector: 'app-trinity-request',
  templateUrl: './trinity-request.component.html',
  styleUrls: ['./trinity-request.component.scss']
})
export class TrinityRequestComponent implements OnInit, OnDestroy {
  public selectedValue = "India";
  public uuid:string='';
  // precio = 12;
  public defaultSecNccsLsm = "SEC";
  public selecteValueSecNccsLsm = [ "A", "B" ];
  public defaultSecNccsLsmSpan:number = 3;
  public selectedGender = "Both";
  public isInterlokingQuotaOn = false;
  public isResetForm = false;
  public quoteObj:any = [];
  public quoteObjSection:any = {};
  public previousRequest="";
  public sampleSize=0;
  public isSaveAndNext:boolean=true;
  public gridTypeData = [];
  // public gridTypeDataCopy = [[{"key":"center","label":"","type":"single-select","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"pct":40,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Rest","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Rest","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}],[{"key":"center","label":"Total","type":"label","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":true,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Rest","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Rest","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}]];
  public gridTypeDataCopy = [[{"key":"center","label":"","type":"single-select","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"pct":40,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Any","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"pct":80,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"pct":60,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"pct":20,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Any","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}],[{"key":"center","label":"Total","type":"label","value":"center","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":true,"show":true,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Any","type":"text","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"show":true,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Any","value":"rest","required":true,"disabled":false,"show":true,"placeholder":"","group_label":"Other","selectedValue":""}]];
  // get placeholderText(): string {
  //   return this.selectedCities.length > 0 
  //     ? this.selectedCities.join(' or ') 
  //     : 'Select cities';
  // }
  constructor(
    public sanitization: DomSanitizer,
    public trinityService: TrinityService,
    private notifier:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute
  ) { 
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.trinityService.trinityUUid = this.uuid;
    this.gridTypeData = JSON.parse(JSON.stringify(this.gridTypeDataCopy));
  }
  ngOnDestroy(): void {
    this.trinityService.tid = "";
    this.trinityService.trinityUUid = "";
    this.isSaveAndNext = true;
    this.trinityService.trinityWidgetData = [];
    this.trinityService.isShowDownload = true
    this.trinityService.trinityQuoteSavePayloadObject = {};
    this.trinityService.trinityQuoteSavePrevPayloadObject = "";
  }

  ngOnInit(): void {
    this.trinityService.trinityQuoteSaveId = this.uuid;
    this.getQuoteForm();
    // if (this.uuid && this.uuid != '') {
    //   this.getQuoteDetails();
    // }
    // this.initQuoteObj();
  }

  onSelectSingleDropdown(value,index){
  }

  getQuoteForm() {
    this.trinityService.getQuoteForm().subscribe((result) => {
      if (result["status"] == 1) {
        this.quoteObj = result['data'];
        if (this.uuid && this.uuid != '' && !this.isResetForm) {
          this.isSaveAndNext = false;
          this.getQuoteDetails();
        }else{
          this.isResetForm = false;
          this.isSaveAndNext = true;
          this.quoteObjSection = {};
          this.initQuoteObj();
        }
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }

  getQuoteDetails() {
    this.trinityService.getQuoteDetails(this.uuid).subscribe((result) => {
      if (result["status"] == 1) {
        let data = result['data'];
        this.trinityService.tid = result["tid"];
        this.trinityService.trinityWidgetData = result.cost_misc	|| {};
        // this.trinityService.trinityWidgetData['sampling_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5,"hideKey":"Discount"}
        // this.trinityService.trinityWidgetData['professional_discount'] = {"values":[5,10,15,20],"name":"Discount","action":{"type":"button","name":"Apply"},"selectedValue":5}
        
        // if(result.cost_misc && result.cost_misc['overall'] && result.cost_misc['overall'].Feasibilty){
        //   this.trinityService.isPMFeasibilty = result.cost_misc['overall']['Feasibilty']["value"] == 'Sent to PM' ? true : false;
        // } 
        this.trinityService.checkPMFeasibility(result);
        this.trinityService.setTrinityQuoteSaveName(result.quote_name);
        this.trinityService.setTrinityQuoteRequestId(result.tid);
 
        this.reAssignQuoteObj(data); 
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })

  }

  initQuoteObj(){
    this.trinityService.showDataSaving = false;
    this.quoteObj.forEach((field,index) => {
      this.quoteObjSection[field.group_label] = this.quoteObjSection[field.group_label] ? this.quoteObjSection[field.group_label] : {'values':[]};
      this.quoteObjSection[field.group_label]["show"] = field.group_label == 'GENERAL' ? true : false;
      field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? field["selectedValue"] : field["selectedValue"] >= 0 ? field["selectedValue"] : "";
      if (field["type"] == 'toggle') {        
        field["selectedValue"] = field["key"] == "interlocking_quota" ? this.isInterlokingQuotaOn : field["selectedValue"] == '' ? false : field["selectedValue"];
        // field["selectedValue"] = this.isInterlokingQuotaOn;
      }else if (field["type"] == 'from-to') {
        field["selectedValue"] = {from:field["value"]["from"],to:field["value"]["to"]};
      }else if (field["type"] == 'grid') {
        field["selectedValue"] = this.gridTypeData;
      }else if (field["type"] == 'single-select' && field["disabled"]) {
        let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
        field["selectedValue"] = option && option["label"] ? option["label"] : "";
      }
      
      this.quoteObjSection[field.group_label]["values"].push(field);
    });
    delete this.quoteObjSection['OTHERS'];
    this.onDependencyChangeInInterlokingQuota();
  }

  reAssignQuoteObj(data){
    this.trinityService.showDataSaving = true;
    let quoteObjSectionCopy = {}
    let dependentFieldCheck = [];
    
    this.quoteObj.forEach((field,index) => {
      quoteObjSectionCopy[field.group_label] = (quoteObjSectionCopy && quoteObjSectionCopy[field.group_label]) ? quoteObjSectionCopy[field.group_label] : {"values": []};
      quoteObjSectionCopy[field.group_label]["show"] = true;
      this.trinityService.trinityQuoteSavePayloadObject = data;
      this.trinityService.trinityQuoteSavePrevPayloadObject = JSON.stringify(data);
      if (Object.keys(data).includes(field["id"] +'')) {
        field["selectedValue"] = data[field["id"]];
        if (field["id"] == 19) {
          field["selectedValue"] = field["selectedValue"] == "0" ? false : true;
        }
        if (field["type"] == 'grid') {
          this.gridTypeData = JSON.parse(field["selectedValue"]);
          field["selectedValue"] = this.gridTypeData;
        }else if (field["type"] == 'checkbox') {
          field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? JSON.parse(field["selectedValue"]) : [] ;
        }else if (field["type"] == 'from-to') {
          field["selectedValue"] = JSON.parse(field["selectedValue"]);
        }else if (field["type"] == 'toggle' && field["key"] == "interlocking_quota") {
          this.isInterlokingQuotaOn = field["selectedValue"] == '' ? false : field["selectedValue"];
        }
        if (field["id"] == 29) {
          field["selectedValue"] = JSON.parse(field["selectedValue"]);
        }
        
        if (field.key == "pitch_simulation" && field.id == 3) {
          this.trinityService.isShowDownload = field.selectedValue == 'Create Simulation' ? false : true;
        }

        if (field["dependent"] && field["dependent"]["to"] || (field["key"]=="gender" && field["selaectedValue"] != "")) {
          dependentFieldCheck.push(field);
        }

        if (field["label"] == "Sample Size") {
          this.sampleSize = field.selectedValue;
        }
      }else{
        field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? field["selectedValue"] : "";
        if (field["type"] == 'toggle') {
          // field["selectedValue"] = this.isInterlokingQuotaOn;
          field["selectedValue"] = field["key"] == "interlocking_quota" ? this.isInterlokingQuotaOn : field["selectedValue"] == '' ? false : field["selectedValue"];
        }else if (field["type"] == 'checkbox') {
          field["selectedValue"] = field["selectedValue"] && field["selectedValue"] != '' ? JSON.parse(field["selectedValue"]) : [] ;
        }else if (field["type"] == 'from-to') {
          field["selectedValue"] = {from:field["value"]["from"],to:field["value"]["to"]};
        }else if (field["type"] == 'grid') {
          field["selectedValue"] = this.gridTypeData;
        }else if (field["type"] == 'single-select' && field["disabled"]) {
          let option = Object.values(field["value"]).find((item) => { return item["selected"] && item["selected"] == true });
          field["selectedValue"] = option && option["label"] ? option["label"] : "";
          this.trinityService.trinityQuoteSavePayloadObject[field.id] = option && option["label"] ? option["label"] : "";
        }
      }
      quoteObjSectionCopy[field.group_label]["values"].push(field);
    });
    delete quoteObjSectionCopy['OTHERS'];
    this.quoteObjSection = JSON.parse(JSON.stringify(quoteObjSectionCopy));
    dependentFieldCheck.forEach((field) => {
      this.onRadioChange(field,true);
    })
    this.setGernalAutoSaveOn();
    this.onDependencyChangeInInterlokingQuota();
  }

  checkSection(){
    if (this.quoteObjSection && Object.keys(this.quoteObjSection).length) {
      return true;
    }else{
      return false;
    }
  }

  formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }

  

  getGridStyle(type: string) {
    if (type === 'grid' || type === 'textarea') { // condition for the item to span both columns
      return { 'grid-column': 'span 2' };
    }
    return {};
  }

  onReset(){
    this.isResetForm = true;
    this.isInterlokingQuotaOn = false;
    this.gridTypeData = JSON.parse(JSON.stringify(this.gridTypeDataCopy));
    this.getQuoteForm();
    // this.initQuoteObj();
  }

 

  

  onDependencyChangeInInterlokingQuota(){
    this.gridTypeData.forEach((gridRow, rowIndex) => {
      gridRow.forEach((gridItem, cellIndex) => {
        if (this.isInterlokingQuotaOn) {
          if(gridItem.group_label == "Gender" || gridItem.group_label == "Other"){
            if (rowIndex == this.gridTypeData.length - 1) {
              gridItem.disabled = true;
              gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
            }else{
              if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
                gridItem.disabled = this.selectedGender == "Both" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
                gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
                gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              }else{
                gridItem.disabled = false;
                gridItem.placeholder = "";
                gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              }
            }
          }
        }else{
          if(gridItem.group_label == "Gender" || gridItem.group_label == "Other"){
            if (rowIndex < this.gridTypeData.length - 1) {
              gridItem.disabled = true;
              // gridItem.placeholder = gridItem.disabled ? "Any" :"";
              // gridItem.selectedValue = gridItem.disabled ? "Any" :gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
                let makeNA = this.selectedGender == "Both" ? false : true;
                gridItem.placeholder = makeNA ? "NA" :"Any";
                gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
                let makeNA = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
                gridItem.placeholder = makeNA ? "NA" :"Any";
                gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
                let makeNA =  this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
                gridItem.placeholder = makeNA ? "NA" :"Any";
                gridItem.selectedValue = makeNA ? "NA" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
              }else{
                gridItem.placeholder = gridItem.disabled ? "Any" :"";
                gridItem.selectedValue = gridItem.disabled ? "Any" :(gridItem.selectedValue == 'Any' || gridItem.selectedValue == 'NA')? "" : gridItem.selectedValue;
              }
            }else{
              if (gridItem.group_label == "Gender" && gridItem.key == "rest") {
                gridItem.disabled = this.selectedGender == "Both" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "M") {
                gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Male" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
              }else if (gridItem.group_label == "Gender" && gridItem.key == "F") {
                gridItem.disabled = this.selectedGender == "Both" || this.selectedGender == "Female" ? false : true;
                gridItem.placeholder = gridItem.disabled ? "NA" :"";
                gridItem.selectedValue = gridItem.disabled ? "NA" :gridItem.selectedValue == 'NA'? "" : gridItem.selectedValue;
              }else{
                gridItem.disabled = false;
                gridItem.placeholder = "";
                gridItem.selectedValue = gridItem.selectedValue == 'NA' || gridItem.selectedValue == 'Any'? "" : gridItem.selectedValue;
              }
            }
          }
        }
       
      });
    });
  }

  

  checkDependent(fields,currentFieldId,selectedValue){
    let isAutoSave = false;
    let keysToBeModified = ['disable','disabled','show','selectedValue','validation'];
    fields.forEach(field => {
      isAutoSave = false;
      let dependentToField = this.quoteObj.find((item) => item.id == field.id);
      if (dependentToField) {
        // if (field.value.includes(selectedValue)) {
        //   dependentToField.disabled = field.disable;
        //   dependentToField.show = field.show;
        //   if(field.selectedValue && field.selectedValue != '' && !(dependentToField.selectedValue && dependentToField.selectedValue != '')){
        //     dependentToField.selectedValue = field.selectedValue;
        //     isAutoSave = true;
        //     this.appendToQuoteObjPayload(dependentToField);
        //   }
        // }
        if (field.value.includes(selectedValue)) {
          
          Object.keys(field).forEach((fKey) => {
            if(keysToBeModified.includes(fKey)) {
              let fkey1 = fKey == 'disable' ? 'disabled' : fKey;
                if(fKey == 'selectedValue'){
                  if (field.selectedValue && field.selectedValue != '' && !(dependentToField.selectedValue && dependentToField.selectedValue != '')) {
                    dependentToField.selectedValue = field.selectedValue;
                    isAutoSave = true;
                    this.appendToQuoteObjPayload(dependentToField);
                  }
                }else{
                  dependentToField[fkey1] = field[fKey];
                }
            }
          });

          this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
            if(fItem.id == field.id){
              Object.keys(field).forEach((fKey) => {
                if(keysToBeModified.includes(fKey)) {
                  let fkey1 = fKey == 'disable' ? 'disabled' : fKey;
                  fItem[fkey1] = dependentToField[fkey1];
                  if(fKey == 'validation'){
                    // dependentToField[fkey1] = field[fKey];
                    let validatedField = this.validateDependentFieldValue(dependentToField);
                    fItem["selectedValue"] = validatedField["selectedValue"];
                  }
                }
              })
              if(isAutoSave){
                fItem.selectedValue = dependentToField.selectedValue;
              }
            }
          })
        }
       


        // this.quoteObjSection[dependentToField.group_label]["values"].forEach((fItem) => {
        //   if(fItem.id == field.id){
        //     fItem.disabled = dependentToField.disabled;
        //     fItem.show = dependentToField.show;
        //     if(isAutoSave){
        //       fItem.selectedValue = dependentToField.selectedValue;
        //     }
        //   }
        // })
      }

      
    });
  }

  styleTrust(data: any): any {
    let count = data.length;

    return this.sanitization.bypassSecurityTrustStyle('repeat(' + (count) + ', 1fr)');
  }

  onAddGridRow(){
    // let gridBlankTR = [{"key":"center","label":"","type":"single-select","value":"center","required":true,"disabled":false,"placeholder":"","group_label":"Center","selectedValue":""},{"key":"sample","label":"","type":"text","value":"sample","required":true,"disabled":false,"placeholder":"","group_label":"Sample","selectedValue":""},{"key":"M","label":"M","type":"text","value":"male","required":true,"disabled":false,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"F","label":"F","type":"text","value":"female","required":true,"disabled":false,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"rest","label":"Rest","type":"text","value":"rest","required":true,"disabled":false,"placeholder":"","group_label":"Gender","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"B","label":"B","type":"text","value":"B","required":true,"disabled":false,"placeholder":"","population_classification":"SEC","group_label":"Other","selectedValue":""},{"key":"A","label":"A","type":"text","value":"A","required":true,"disabled":false,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"A,B","label":"A,B","type":"text","value":"A,B","required":true,"disabled":false,"placeholder":"","population_classification":"NCCS","group_label":"Other","selectedValue":""},{"key":"5-7","label":"5-7","type":"text","value":"5-7","required":true,"disabled":false,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"8-11","label":"8-11","type":"text","value":"8-11","required":true,"disabled":false,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"11+","label":"11+","type":"text","value":"11+","required":true,"disabled":false,"placeholder":"","population_classification":"LSM","group_label":"Other","selectedValue":""},{"key":"rest","type":"text","label":"Rest","value":"rest","required":true,"disabled":false,"placeholder":"","group_label":"Other","selectedValue":""}]
    let gridBlankTR = JSON.parse(JSON.stringify(this.gridTypeDataCopy[0]));
    this.gridTypeData.splice(this.gridTypeData.length - 1, 0, gridBlankTR);
    this.onDependencyChangeInInterlokingQuota();
  }

  onCenterChange(event,trIndex,centers,field,item){
    const prevSelectedCentersKeys = item && item.prevSelectedValue ? item.prevSelectedValue : [];
    const addedCenters = event.value.filter((key) => !prevSelectedCentersKeys.includes(key));
    if(addedCenters.length > 0){
      let addedCenterKey = addedCenters[0];
      if(addedCenterKey == 'any'){
        event.value = [addedCenterKey];
      }else{
        if(prevSelectedCentersKeys.includes('any')){
          event.value = [...event.value.filter((key) => key != 'any')]
        }
      }
      item.selectedValue = event.value;
    }
    

    // let selectedCenters = this.centers.filter((center) => event.value.includes(center.key));
    let selectedCenters = centers.filter((center) => event.value.includes(center.key));
    
    let maxQuotaLimit = {
      "gender": {
      "male": 0,
      "female": 0,
      "rest": 0
    },
    "sec": {
      "a": 0,
      "b": 0
    },
    "nccs": {
      "a": 0,
      "b": 0
    },
    "lsm": {
      "a": 0,
      "b": 0
    },
    // "max_in_center": 0,
    "sample": 0
    }

    selectedCenters.forEach((center) => {
      maxQuotaLimit["gender"]["male"] += center["gender"]["male"]
      maxQuotaLimit["gender"]["female"] += center["gender"]["female"]
      maxQuotaLimit["gender"]["rest"] += center["max_in_center"]
      maxQuotaLimit["sec"]["a"] += center["sec"]["a"]
      maxQuotaLimit["sec"]["b"] += center["sec"]["b"]
      maxQuotaLimit["nccs"]["a"] += center["nccs"]["a"]
      maxQuotaLimit["nccs"]["b"] += center["nccs"]["b"]
      maxQuotaLimit["lsm"]["a"] += center["lsm"]["a"]
      maxQuotaLimit["lsm"]["b"] += center["lsm"]["b"]
      maxQuotaLimit["other"] = {"rest":0}
      maxQuotaLimit["other"]["rest"] += center["max_in_center"]
      maxQuotaLimit["sample"] += center["max_in_center"]
    });
    this.setCentersQuotaLimit(maxQuotaLimit, trIndex)
    let id = field.id+"";
    this.trinityService.trinityQuoteSavePayloadObject[id] = field.selectedValue;
    item.prevSelectedValue = [...item.selectedValue];
    this.isAnyChangeInTrinitSaveQuotePayload();
    
  }

  setCentersQuotaLimit(quotaLimit, rowIndex){
    this.gridTypeData[rowIndex].forEach((gridItem) => {
      if (gridItem.group_label == "Sample") {
        gridItem["maxValue"] = quotaLimit["sample"];
      }else if (gridItem.group_label == "Gender" && gridItem.key == "M") { 
        gridItem["maxValue"] = quotaLimit["gender"]["male"]
      }else if (gridItem.group_label == "Gender" && gridItem.key == "F") { 
        gridItem["maxValue"] = quotaLimit["gender"]["female"]
      }else if (gridItem.group_label == "Gender" && gridItem.key == "rest") { 
        gridItem["maxValue"] = quotaLimit["gender"]["rest"]
      }else if (gridItem.group_label == "Other" && gridItem.key == "A") { 
        gridItem["maxValue"] = quotaLimit[this.defaultSecNccsLsm.toLocaleLowerCase()]["a"]
      }else if (gridItem.group_label == "Other" && gridItem.key == "B") { 
        gridItem["maxValue"] = quotaLimit[this.defaultSecNccsLsm.toLocaleLowerCase()]["b"]
      }else if (gridItem.group_label == "Other" && gridItem.key == "rest") { 
        gridItem["maxValue"] = quotaLimit["other"]["rest"]
      }
    });
  }

  onQuotaItemFocusOut(item,itemIndex,rowIndex,field){
    field.selectedValue = this.gridTypeData;
    if (itemIndex == 1 && this.isInterlokingQuotaOn) {
      this.setDefaultQuoteBySampleSize(rowIndex, item, itemIndex, field);
    }else{
      this.validateQuotaItem(item,itemIndex,rowIndex,field);
    }
   
  }

  validateQuotaItem(item,itemIndex,rowIndex,field){

    if ((item.maxValue && Number(item.selectedValue) > item.maxValue)) {
      this.notifier.notify('error','This center allow maximun '+ item.maxValue + ' ' + item.value + ' !');
    }else if (rowIndex < this.gridTypeData.length - 1) {
      var totalSamplesaize = 0;
      this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue = itemIndex==1? this.sampleSize: "0";
      this.gridTypeData.forEach((gridRow,rIndex) => {
        if (rIndex != this.gridTypeData.length - 1) {
          gridRow.forEach((gridItem) => {
            if (gridItem.group_label == item.group_label && gridItem.key == item.key) {
              if (itemIndex != 1) {
                this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue = Number(this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue) + Number(gridItem.selectedValue) + "";
              }else{
                totalSamplesaize += Number(gridItem.selectedValue);
              }
            }
          });
          // if (itemIndex != 1) {
          //   this.gridTypeData[this.gridTypeData.length - 1][itemIndex].selectedValue = 0;
          // }
          // gridRow.forEach((gridItem, iIndex) => {
          //   if (gridItem.group_label == item.group_label) {
          //     if (iIndex != 1) {
          //       this.gridTypeData[this.gridTypeData.length - 1][iIndex].selectedValue = Number(this.gridTypeData[this.gridTypeData.length - 1][iIndex].selectedValue) + Number(gridItem.selectedValue) + "";
          //     }else{
          //       totalSamplesaize += Number(gridItem.selectedValue);
          //     }
          //   }
          // });
          
        }
      });
      let rowSample = 0;
      let rowGender = 0;
      let rowOther = 0;
      this.gridTypeData[rowIndex].forEach((gridItem) => {
        if (gridItem.group_label == "Sample") {
          rowSample = Number(gridItem.selectedValue);
        }else if (gridItem.group_label == "Gender"){
          let value = gridItem.selectedValue == '' || gridItem.selectedValue == 'NA' ? 0 : Number(gridItem.selectedValue);
          rowGender += value;
        }else if (gridItem.group_label == "Other"){
          rowOther += Number(gridItem.selectedValue);
        }
      })


      if (rowGender > rowSample) {
        this.notifier.notify('error','Total gender should not be greater than sample size  '+rowSample+'!');
      }else if (rowOther > rowSample) {
        this.notifier.notify('error','Total '+this.defaultSecNccsLsm+' should not be greater than sample size '+rowSample+'!');
      }
      let id = field.id+"";
      this.trinityService.trinityQuoteSavePayloadObject[id] = field.selectedValue;
      setTimeout(() =>{
        this.isAnyChangeInTrinitSaveQuotePayload();
      },10)
    }else if (rowIndex == this.gridTypeData.length - 1){
      let rowSample = 0;
      let rowGender = 0;
      let rowOther = 0;
      this.gridTypeData[rowIndex].forEach((gridItem) => {
        if (gridItem.group_label == "Sample") {
          rowSample = Number(gridItem.selectedValue);
        }else if (gridItem.group_label == "Gender"){
          let value = gridItem.selectedValue == '' || gridItem.selectedValue == 'NA' ? 0 : Number(gridItem.selectedValue);
          rowGender += value;
        }else if (gridItem.group_label == "Other"){
          rowOther += Number(gridItem.selectedValue);
        }
      })
      if (rowGender > rowSample) {
        this.notifier.notify('error','Total gender should not be greater than sample size  '+rowSample+'!');
      }else if (rowOther > rowSample) {
        this.notifier.notify('error','Total '+this.defaultSecNccsLsm+' should not be greater than sample size '+rowSample+'!');
      }
      let id = field.id+"";
      this.trinityService.trinityQuoteSavePayloadObject[id] = field.selectedValue;
      setTimeout(() =>{
        this.isAnyChangeInTrinitSaveQuotePayload();
      },10)
    }

    if (totalSamplesaize > this.sampleSize) {
      this.notifier.notify('error','Total sample size should not be greater than '+ this.sampleSize + ' !');
    }
  }

  checkInterlokingQuotaValidation(item,trIndex){
    if ((item.maxValue && Number(item.selectedValue) > item.maxValue)) {
      return 'error';
    }else{
      return 'no-error';
    }
  }

  setDefaultQuoteBySampleSize(rowIndex, item,itemIndex,field){
    let genderCheck = {"disabled":false,"label":""};
    this.gridTypeData[rowIndex].forEach((gridItem) => {
      if (gridItem.group_label == "Gender" && gridItem.show && gridItem.pct) {
        if (!gridItem.disabled) {
          let pctValue = (Number(item.selectedValue) * gridItem.pct) / 100;
          gridItem.selectedValue = pctValue;
        }else{
          genderCheck["disabled"] = true;
          genderCheck["label"] = gridItem.label;
        }
      }else if (gridItem.group_label == "Other" && gridItem.population_classification && gridItem.population_classification == this.defaultSecNccsLsm && gridItem.show && !gridItem.disabled && gridItem.pct) {
        let pct = gridItem.pct;

        if(this.defaultSecNccsLsm == "LSM"){
          if(gridItem.label == "8-11"){
            pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : this.selecteValueSecNccsLsm.length == 2 ? 80 : this.selecteValueSecNccsLsm.length == 3 ? 60 : gridItem.pct;
          }else{
            pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : 20;
          }
        }else{
          pct = this.selecteValueSecNccsLsm.length == 1 ? 100 : gridItem.pct;
        }
        let pctValue = (Number(item.selectedValue) * pct) / 100;
        // let pctValue = (Number(item.selectedValue) * gridItem.pct) / 100;
        gridItem.selectedValue = pctValue;
      }
    });
    this.selecteValueSecNccsLsm

    if (genderCheck["disabled"]) {
      if (genderCheck["label"] == "M") {
        this.gridTypeData[rowIndex][3].selectedValue = (Number(item.selectedValue) * 100) / 100;
      }else{
        this.gridTypeData[rowIndex][2].selectedValue = (Number(item.selectedValue) * 100) / 100;
      }
    }
    this.validateQuotaItem(item,itemIndex,rowIndex,field);
  }

  onRadioChange(field, isReassign?:boolean){
    if (field.key == "sec_nccs_lsm") {
      this.defaultSecNccsLsm = field.selectedValue;
      let preSelecteValueSecNccsLsm = this.defaultSecNccsLsm == "SEC" ? this.quoteObjSection["TARGET GROUP"]["values"].find((item) => item.id == 27).selectedValue : this.defaultSecNccsLsm == "NCCS" ? this.quoteObjSection["TARGET GROUP"]["values"].find((item) => item.id == 28).selectedValue : this.defaultSecNccsLsm == "LSM" ? this.quoteObjSection["TARGET GROUP"]["values"].find((item) => item.id == 29).selectedValue : [];
      // let preSelecteValueSecNccsLsm = this.defaultSecNccsLsm == "SEC" ? this.trinityService.trinityQuoteSavePayloadObject["27"] : this.defaultSecNccsLsm == "NCCS" ? this.trinityService.trinityQuoteSavePayloadObject["28"] : this.defaultSecNccsLsm == "LSM" ? this.trinityService.trinityQuoteSavePayloadObject["29"] : [];
      preSelecteValueSecNccsLsm = preSelecteValueSecNccsLsm && preSelecteValueSecNccsLsm != '' ? preSelecteValueSecNccsLsm : [];
      if (this.defaultSecNccsLsm == "LSM" && preSelecteValueSecNccsLsm.length == 0) {
        this.quoteObjSection["TARGET GROUP"]["values"].find((item) => item.id == 29).selectedValue = ["8-11"];
        this.trinityService.trinityQuoteSavePayloadObject["29"] = this.trinityService.trinityQuoteSavePayloadObject["29"] && this.trinityService.trinityQuoteSavePayloadObject["29"].length ? this.trinityService.trinityQuoteSavePayloadObject["29"] : ["8-11"];
      }
      else if (this.defaultSecNccsLsm == "SEC" && preSelecteValueSecNccsLsm.length != 0) {
        this.trinityService.trinityQuoteSavePayloadObject["27"] = preSelecteValueSecNccsLsm.isArray ? preSelecteValueSecNccsLsm : preSelecteValueSecNccsLsm != '' ? preSelecteValueSecNccsLsm.split(",") : "";
      }else if (this.defaultSecNccsLsm == "NCCS" && preSelecteValueSecNccsLsm.length != 0) {
        this.trinityService.trinityQuoteSavePayloadObject["28"] = preSelecteValueSecNccsLsm.isArray ? preSelecteValueSecNccsLsm : preSelecteValueSecNccsLsm != '' ? preSelecteValueSecNccsLsm.split(",") : "";
      }
      this.selecteValueSecNccsLsm = (preSelecteValueSecNccsLsm && preSelecteValueSecNccsLsm.length) ? preSelecteValueSecNccsLsm : this.defaultSecNccsLsm == "LSM" ?["8-11"] :  ["A","B"];
      this.updateGrid();
    }else if (field.key == "gender") {
      this.selectedGender = field.selectedValue;
      this.onDependencyChangeInInterlokingQuota();
    }else if (field.key == "pitch_simulation" && field.id == 3) {
      // this.trinityService.isShowDownload = field.selectedValue == 'Create Simulation' ? false : true;
      this.checkDownloadable();
    }
    let dependent = field.dependent ? field.dependent : null;
    if (dependent && dependent.to) {
      this.checkDependent(dependent.to,field.id,field.selectedValue);
    }
    if (isReassign) {
      this.appendToQuoteObjPayload(field, true);
    }else{
      this.appendToQuoteObjPayload(field);
    }
  }

  // onCheckboxChange(field, isReassign?:boolean){
  //   console.log("onCheckboxChange field ===> ",field);
  // }


  isCheckboxSelected(field: any, label: string): boolean {
    return Array.isArray(field.selectedValue) &&
           field.selectedValue.includes(label);
  }

  onCheckboxToggle(field: any, label: string, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (!Array.isArray(field.selectedValue)) {
      field.selectedValue = [];
    }
    if (checked) {
      // add if not already there
      if (!field.selectedValue.includes(label)) {
        field.selectedValue.push(label);
      }
    } else {
      // remove it
      const idx = field.selectedValue.indexOf(label);
      if (idx > -1) {
        field.selectedValue.splice(idx, 1);
      }
    }
     if (this.validateField(field)) {
      this.appendToQuoteObjPayload(field);
    }
  }

  checkDownloadable(){
    this.trinityService.isShowDownload = this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 3).selectedValue == 'I have pitch ID' && this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 4).selectedValue != '' && this.quoteObjSection["GENERAL"]["values"].find((item) => item.id == 5).selectedValue != '' ? true : false;
  }
  onInputFiledFocusOut(field:any){
    if (field["label"] == "Sample Size") {
      this.gridTypeData[this.gridTypeData.length - 1][1].selectedValue = field.selectedValue;
      this.sampleSize = field.selectedValue;
    }
    let value = field.selectedValue + "";
    if (field.id == 4 || field.id == 5) {
      this.checkDownloadable();
    }
    // this.validateField(field);
    // if(value == '' && field.required){
    //   this.notifier.notify('error',field.label + ' is required !');
    // }else{
    //   this.appendToQuoteObjPayload(field);
    // }

    if (this.validateField(field)) {
      this.appendToQuoteObjPayload(field);
      
    }
  }

  onSelectChange(selectCtrl:MatSelect,field:any){
    if (field.id == 27 || field.id == 28) {
      this.selecteValueSecNccsLsm = field.selectedValue.split(",");
      this.updateGrid();
    }else if (field.id == 29) {
      if (!(field.selectedValue.includes('8-11'))) {
        field.selectedValue.push('8-11');
        selectCtrl.options.forEach(option => {
          if (option.value == '8-11') {
            option.select();
            this.notifier.notify('warning','8-11 is required!');
          }
        });
      }
      this.selecteValueSecNccsLsm = field.selectedValue;
      this.updateGrid();
    }
    this.appendToQuoteObjPayload(field);
  }

  updateGrid(){
    this.defaultSecNccsLsmSpan = this.selecteValueSecNccsLsm.length + 1
    this.gridTypeData.forEach((gridRow, rowIndex) => {
      gridRow.forEach((gridItem, cellIndex) => {
        if (gridItem.group_label == "Other" ) {
          if ((gridItem.population_classification && gridItem.population_classification == this.defaultSecNccsLsm && this.selecteValueSecNccsLsm.includes(gridItem.label)) || gridItem.label == "Rest") {
            gridItem["show"] = true;
            if (this.gridTypeDataCopy[rowIndex]) {
              this.gridTypeDataCopy[rowIndex][cellIndex]["show"] = true;
            }
          }else{
            gridItem["show"] = false;
            if (this.gridTypeDataCopy[rowIndex]) {
              this.gridTypeDataCopy[rowIndex][cellIndex]["show"] = false;
            }
          }
        }
      })
    });
  }

  onSliderChange(field:any){ 
    this.appendToQuoteObjPayload(field);
  }

  appendToQuoteObjPayload(field, isReassign?:boolean){
    let id = field.id+"";
    this.trinityService.trinityQuoteSavePayloadObject[id] = field.selectedValue;
    if (field && field.misc && field.misc.auto_save && !this.isSaveAndNext && !isReassign) {
      this.isAnyChangeInTrinitSaveQuotePayload();
    }
  }

  onSelectChangeForFromTo(field,option,type){
    let id = field.id+"";
    if(!this.trinityService.trinityQuoteSavePayloadObject[id]){
      this.trinityService.trinityQuoteSavePayloadObject[id] = {};
    }else{
      this.trinityService.trinityQuoteSavePayloadObject[id] = typeof this.trinityService.trinityQuoteSavePayloadObject[id]  === 'string' ? JSON.parse(this.trinityService.trinityQuoteSavePayloadObject[id]) : this.trinityService.trinityQuoteSavePayloadObject[id];
    }
    this.trinityService.trinityQuoteSavePayloadObject[id][type] = option.value.label;
    if (field && field.misc && field.misc.auto_save) {
      this.isAnyChangeInTrinitSaveQuotePayload();
    }
  }

  onToggleChange(field){
    if (field.key == "interlocking_quota") {
      this.isInterlokingQuotaOn = field.selectedValue;
      this.onDependencyChangeInInterlokingQuota();
    }
    let id = field.id+"";
    this.trinityService.trinityQuoteSavePayloadObject[id] = field.selectedValue;
    if (field && field.misc && field.misc.auto_save) {
      this.isAnyChangeInTrinitSaveQuotePayload();
    }
  }

  removeBlankIDs(){
    if (this.trinityService.trinityQuoteSavePayloadObject["27"] == "") {
      delete this.trinityService.trinityQuoteSavePayloadObject["27"];
    }
    if (this.trinityService.trinityQuoteSavePayloadObject["28"] == "") {
      delete this.trinityService.trinityQuoteSavePayloadObject["28"];
    }
    if (this.trinityService.trinityQuoteSavePayloadObject["29"] == "") {
      delete this.trinityService.trinityQuoteSavePayloadObject["29"];
    }
    if (this.defaultSecNccsLsm == "SEC") {
      delete this.trinityService.trinityQuoteSavePayloadObject["28"];
      delete this.trinityService.trinityQuoteSavePayloadObject["29"];
    }else if (this.defaultSecNccsLsm == "NCCS") {
      delete this.trinityService.trinityQuoteSavePayloadObject["27"];
      delete this.trinityService.trinityQuoteSavePayloadObject["29"];
    }else if (this.defaultSecNccsLsm == "LSM"){
      delete this.trinityService.trinityQuoteSavePayloadObject["27"];
      delete this.trinityService.trinityQuoteSavePayloadObject["28"];
    }
  }
  isAnyChangeInTrinitSaveQuotePayload(){
    this.removeBlankIDs();
    let currentPayload = this.trinityService.trinityQuoteSavePayloadObject;
    if(!this.trinityService.trinityQuoteSavePrevPayloadObject){
      this.trinityService.trinityQuoteSavePrevPayloadObject = JSON.stringify(currentPayload);
      this.trinityService.saveTrinityQuotePayload();
    }else{
      if (JSON.stringify(currentPayload) != this.trinityService.trinityQuoteSavePrevPayloadObject) {
        this.trinityService.trinityQuoteSavePrevPayloadObject = JSON.stringify(currentPayload);
        this.trinityService.saveTrinityQuotePayload();
      }
    }
  }

  checkVisivility(trIndex){
    if(this.gridTypeData.length > 2 && trIndex != this.gridTypeData.length - 1){
      return true; 
    }else{
      return false;
    }
  }
  onDeleteGridRow(trIndex){
    this.gridTypeData.splice(trIndex, 1);
    
  }

  backToTrinityList(){
    this.router.navigate(['/trinity']);
  }

  toggleDropdown(index: number, select: MatSelect) {
    if (select.panelOpen) {
      select.close();
    } else {
      select.open();
    }
  }

  getSelectedCenters(centers, length?:number){
    if (centers && centers.length && centers.length > 0) {
      let centerList = centers;
      let newStr = "";
      centerList.forEach((strItem, index) => {
        if (index) {
          newStr = newStr +" Or "+ strItem.charAt(0).toUpperCase() + strItem.slice(1).toLowerCase() + " "
        }else{
          newStr = newStr + strItem.charAt(0).toUpperCase() + strItem.slice(1).toLowerCase() + " "
        }
      });
  
      if ( length && newStr.length > length) {
        return newStr.substring(0, length) + '...';
      }else{
        return newStr;
      }
    }else{
      return "";
    }

  }

  onSaveAndNext(){
    if (!(this.trinityService.trinityQuoteSavePayloadObject && this.trinityService.trinityQuoteSavePayloadObject['1'] && this.trinityService.trinityQuoteSavePayloadObject["1"] != "")) {
      this.notifier.notify('error', 'Quote name is required !');
    }else if(!this.trinityService.trinityQuoteSavePayloadObject['3'] || this.trinityService.trinityQuoteSavePayloadObject["3"] == ""){
      this.notifier.notify('error', "Please select either 'I have pitch ID' or 'Create Simulation'");
    }else if(this.trinityService.trinityQuoteSavePayloadObject['3'] && this.trinityService.trinityQuoteSavePayloadObject["3"] == "I have pitch ID" && !(this.trinityService.trinityQuoteSavePayloadObject['4'] && this.trinityService.trinityQuoteSavePayloadObject["4"] != "")){
      this.notifier.notify('error', 'Pitch ID is required !');
    }
    else if(this.trinityService.trinityQuoteSavePayloadObject['3'] && this.trinityService.trinityQuoteSavePayloadObject["3"] == "I have pitch ID" && !(this.trinityService.trinityQuoteSavePayloadObject['5'] && this.trinityService.trinityQuoteSavePayloadObject["5"] != "")){
      this.notifier.notify('error', 'Client Name is required !');
    }
    else{
      this.setGernalAutoSaveOn();
      this.isSaveAndNext = false;
      Object.keys(this.quoteObjSection).forEach((sectionKey) => {
        this.quoteObjSection[sectionKey]["show"] = true
      });
      this.isAnyChangeInTrinitSaveQuotePayload();
    }
  }

  setGernalAutoSaveOn(){
    this.quoteObjSection['GENERAL']["values"][0]["misc"]["auto_save"] = true;
    this.quoteObjSection['GENERAL']["values"][1]["misc"]["auto_save"] = true;
    this.quoteObjSection['GENERAL']["values"][2]["misc"]["auto_save"] = true;
    this.quoteObjSection['GENERAL']["values"][3]["misc"]["auto_save"] = true;
    this.quoteObjSection['GENERAL']["values"][4]["misc"]["auto_save"] = true;
  }

  validateDependentFieldValue(field:any){
     if (field && field.validation && field.validation.length) {
      for(const validation of field.validation){
        if (validation.type == "less-than-equal-to") {
          // let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
          let selectedValue = this.trinityService.trinityQuoteSavePayloadObject[field.id] ? parseInt(this.trinityService.trinityQuoteSavePayloadObject[field.id]) : 0;
          if (selectedValue > validation.value) {
            field.selectedValue = "";
            this.appendToQuoteObjPayload(field);
            break;
          }else{
            field.selectedValue = selectedValue;
          }
        }
      }
      return field;
    }
    else{
      return field;
    }
  }


  validateField(field:any){
    let isValid = true;

    if (field && field.required && field.show && !field.disabled) {
          if (field.type == 'from-to') {
            if (field.selectedValue && (field.selectedValue["from"] == "" || field.selectedValue["to"] == "")) {
              isValid = false;
            }
          }else if (field.type == 'percent-term' || field.type == 'two_input-pct-term') {
            if (field.selectedValue && field.selectedValue.length < 1 || field.selectedValue.find(item =>{ return item.percent == "" || item.term == ""})) {
              isValid = false;
            }
          }else if (field.type == 'checkbox') {
            if (field.selectedValue && field.selectedValue.length < 1) {
              isValid = false;
            }
          }else{
            field.selectedValue = typeof field.selectedValue  === 'string' ? field.selectedValue.trim() : field.selectedValue;
            if(field.selectedValue == "" || field.selectedValue == null){
              isValid = false;
            }
          }
          if(!isValid){
            field['error'] = true;
            this.notifier.notify('error',field.label + ' is required !');
            return isValid;
          }else{
            field['error'] = false;
          }
        }
    if (field && field.show && field.validation && field.validation.length) {
      for(const validation of field.validation){
        if (validation.type == "regex") {
          if (!((field.selectedValue == "" || field.selectedValue == null) && validation.allow_blank)) {
            const regex = new RegExp(validation.value);
            isValid = regex.test(field.selectedValue);
            if (!isValid) {
              this.notifier.notify('error',validation.message);
              isValid = false;
              break;
              // return isValid;
            }
          }
        }else if (validation.type == "total-invoicing-sum") {
          let totalInvoicing = 0;
          field.selectedValue.forEach((item) => {
            totalInvoicing += item.percent ? parseFloat(item.percent) : 0;
            // totalInvoicing += item.percent ? parseInt(item.percent) : 0;
          });
          if (totalInvoicing != validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            break;
            // return isValid;
          }
        }else if (validation.type == "age-range") {
          if (field.selectedValue["from"] && field.selectedValue["from"] != "" && field.selectedValue["to"] && field.selectedValue["to"] != "") {
            if (!(parseInt(field.selectedValue["from"]) <= parseInt(field.selectedValue["to"]))) {
              isValid = false;
              this.notifier.notify('error',validation.message);
              break;
              // return isValid;
            }
          }

        }else if (validation.type == "date-range-between") {
          let targetGroupLabel = this.quoteObj.find((item) => item.id == validation.value)["group_label"];
          let targetField = this.quoteObjSection[targetGroupLabel]["values"].find((item) => item.id == validation.value);
          if(!targetField.selectedValue["from"] || targetField.selectedValue["from"] == ""){
              this.notifier.notify('error',"Please enter date range for " + targetField.label);
              isValid = false;
              break; 
          }else if(!targetField.selectedValue["to"] || targetField.selectedValue["to"] == ""){
              this.notifier.notify('error',"Please enter date range for " + targetField.label);
              isValid = false;
              break;
          }
          // Parse dates safely and compare ranges
          const parseDate = (d: any) => d instanceof Date ? d : new Date(d);
          const targetFrom = parseDate(targetField.selectedValue["from"]);
          const targetTo = parseDate(targetField.selectedValue["to"]);
          const fieldFrom = parseDate(field.selectedValue["from"]);
          const fieldTo = parseDate(field.selectedValue["to"]);
          if (field.selectedValue["from"] && field.selectedValue["to"]) {
            // Ensure fieldFrom is not before targetFrom and fieldTo is not after targetTo
            if (fieldFrom < targetFrom || fieldTo > targetTo) {
              isValid = false;
              this.notifier.notify('error', validation.message);
              break;
            }
          }
        }else if (validation.type == "less-than-equal-to" && field.selectedValue > validation.value) {
          let selectedValue = field.selectedValue ? parseInt(field.selectedValue) : 0;
          if (selectedValue > validation.value) {
            this.notifier.notify('error',validation.message);
            isValid = false;
            break;
            // return isValid;
          }
        }
      }
    
      if(!isValid){
        field['error'] = true;
      }else{  
        field['error'] = false;
      }
      return isValid;
    }else{
      field['error'] = false;
      return true;
    }
  }
}
